app.controller("MapController",
	["$scope", "$timeout", "GoogleMapService", "ApartmentSearchModel", "ApartmentSearchService", "GeoService", function($scope, $timeout, GoogleMapService, ApartmentSearchModel, ApartmentSearchService, GeoService) {

		$scope.latitude = 0;
		$scope.longitude = 0;
		$scope.mapOptions = {
			zoom: 14,
			center: [60.1619448, 24.9130815],
			scrollwheel: false,
			styles: [
				{
					featureType: "poi",
					stylers: [
						{ visibility: "off" }
					]
				}
			]
		};

		$scope.Utils = window.Utils;

		$scope.$on('infoBoxOpen', function(event, args) {
			args.info.image = args.info.imageAddress;
		});

		$scope.SearchModel = ApartmentSearchModel;
		$scope.SearchService = ApartmentSearchService;

		$scope.SearchModel.query.SetResultLimit(999);
		$scope.SearchModel.query.SetDataFields([
			'key',
			'valueListing',
			'newConstruction'
		]);

		var arvoIcon = 'assets/images/pin-arvo.png';
		var newIcon = 'assets/images/pin-new.png';
		var regularIcon = 'assets/images/pin-regular.png';
		var notSelectedIcon = 'assets/images/pin-not-selected.png';
		var noIcon = 'assets/images/pin-no-icon.png';
		var icon = regularIcon;

		var previousSearchAddress;
		var firstSearchRun = true;
		var previousMapCenter;

		/**
		 * Ajaa molemmat queryt (mapSearch ja mainSearch) oikeassa järjestyksessä.
		 * TODO: mites latausspinnerit? Voidaan tarkkailla resulttisetin loadingia kyllä...
		 */
		function RunBothQuerys(searchParamsObj) {

			if(searchParamsObj === undefined) {
				searchParamsObj = {
					sourceQueryObject: ApartmentSearchModel.query,
					resultIdentifier: "mainSearch",
					appendResults: false,
					callback: undefined
				};
			}
			// Ajetaan ensin mapQuery
			$scope.SearchService.RunQuery($scope.mapQuery, "mapSearch", false, function(success) {

				// Lisätään harmaat markerit.
				AddGreyMarkers();

				// Vasta nyt ajetaan itse mainSearchi.
				$scope.SearchService.RunQuery(searchParamsObj.sourceQueryObject,
					searchParamsObj.resultIdentifier, searchParamsObj.appendResults,
					function(success, resultIdentifier) {
						if(searchParamsObj.callback !== undefined) {
							searchParamsObj.callback(success, resultIdentifier);
						}
						// Ja aivan lopuksi vihreät markerit.
						AddGreenMarkers();
					}, true);

			}, true);
		}

		/**
		 * Lisätään harmaat markerit karttaan.
		 * TODO: kuvat, nyt on asetettu imageAddressiin eikä imageen, koska ei haluta ladata kaikkia kuvia netistä heti.
		 * TODO: vasta kun infobox avataan, pitäisi imageAddress assignoida imageen.
		 */
		function AddGreyMarkers() {

			var results = $scope.SearchModel.results["mapSearch"].data.results;
			for(var i = 0; i < results.length; i++) {
				if(results[i].images[0]) {
					results[i].imageAddress = "/assets"+results[i].images[0].path+"/"+results[i].images[0].name;
				}
				else {
					results[i].imageAddress = "/assets/images/list/noimage-tiny.png";
				}
				var marker = $scope.map.controls.AddMarker([results[i].latitude, results[i].longitude], noIcon, results[i].key);
				if (!marker.placedMarker) {
					$scope.map.controls.AddInfoBox(marker, 'map-infobox.html', null, $scope);
					marker.infoBoxScope.apartments = {};
					marker.infoBoxScope.apartments[results[i].key] = results[i];
					marker.infoBoxScope.info = marker.infoBoxScope.apartments[results[i].key];
					marker.infoBoxScope.marker = results[i].key;
				} else {
					$scope.markers = $scope.map.controls.GetMarkers();
					if(typeof $scope.markers[marker.key].marker.infoBoxScope.apartments[results[i].key] == 'undefined') {
						$scope.markers[marker.key].marker.infoBoxScope.apartments[results[i].key] = results[i];
						$scope.markers[marker.key].marker.infoBoxScope.multipleApartments = true;
					}
				}
			}
			$scope.markers = $scope.map.controls.GetMarkers();
		}

		/**
		 * Lisää vihreät markerit karttaan.
		 */
		function AddGreenMarkers() {

			var results = $scope.SearchModel.results["mainSearch"].data.results;
			for (var key in $scope.markers) {
				if ($scope.markers.hasOwnProperty(key)) {
					$scope.markers[key].marker.setIcon(notSelectedIcon);
					$scope.markers[key].marker.setZIndex(1);
				}
			}
			for (var i = 0; i < results.length; i++) {
				if (results[i].valueListing) {
					icon = arvoIcon;
				} else if (results[i].newConstruction) {
					icon = newIcon;
				} else {
					icon = regularIcon;
				}
				if($scope.markers[results[i].key]) {
					$scope.markers[results[i].key].marker.setIcon(icon);
					$scope.markers[results[i].key].marker.setZIndex(2);
				}
			}
		}

		/**
		 * Hookki, joka ajetaan ennen kuin mainSearch-haku tehdään.
		 * Normaalisti haetaan aina ensin harmaat markerit (mapQuery), ja sen jälkeen ajetaan varsinainen
		 * hakupalkin parametrien mukainen query.
		 *
		 * Palauttaa falsen, eli keskeyttää pyydetyn mainSearch-haun ja tekee täällä omat taikansa,
		 * pyydetty haku ajetaan vasta omien taikojen jälkeen.
		 *
		 * @param searchParamsObj
		 * @returns {boolean} - jatketaanko normaalisti mainSearch-hakua.
		 */
		function ExecBeforeMainSearch(searchParamsObj) {
			var addressConstraint = searchParamsObj.sourceQueryObject.GetAddressConstraints();

			// Jos osoite on muuttunut, hypätään ensin myös uuteen paikkaan kartalla.
			// Köyhän miehen compare...
			if(addressConstraint !== undefined && addressConstraint.length > 0) {

				// TODO: kohdista myös, jos kartan keskipisteen etäisyys on tarpeeksi paljon suuri previousMapCenteristä (ollaan harhauduttu kauas hakupisteestä ja tehtiin uusi haku)
				if(previousSearchAddress === undefined || (angular.toJson(previousSearchAddress[0].value) != angular.toJson(addressConstraint[0].value))) {
					var geocoder = new google.maps.Geocoder();
					var location = addressConstraint[0].value + ", Suomi";
					previousSearchAddress = angular.copy(addressConstraint);

					// TODO: POTENTIAL HAZARD, kuinka monta geokyselyä saa googlen apilta tehdä per päivä?
					geocoder.geocode( { 'address': location }, function(results, status) {
						// Zoomataan kartta osoitteeseen, jos löytyi.
						if (status == google.maps.GeocoderStatus.OK) {
							$scope.map.map.setCenter(results[0].geometry.location);
							previousMapCenter = results[0].geometry.location;
							console.log("setting center");
						}

						RunBothQuerys(searchParamsObj);
					});
				}

			}

			// Sama osoite, ei zoomailuja, ajetaan vaan queryt.
			RunBothQuerys(searchParamsObj);

			// Ei anneta SearchServicen ajaa hakua: alkuperäinen haku ajetaan myöhemmin käsin itse.
			return false;
		}


		$scope.InitMapFunctionality = function(map) {

			$scope.map = map;
			$scope.mapQuery = $scope.SearchService.CreateQuery();
			$scope.mapQuery.SetResultLimit(999);
			$scope.mapQuery.SetDataFields([
				'key',
				'images',
				'valueListing',
				'newConstruction',
				'address',
				'district',
				'city',
				'livingArea',
				'type',
				'roomTypes',
				'salesPriceUnencumbered',
				'latitude',
				'longitude',
				'urlParts'
			]);

			GeoService.RequestPosition(function(coords) {
				if(!coords) {
					return false;
				}
				var locationIcon = new google.maps.MarkerImage(
					'assets/images/location.png',
					null, // size
					null, // origin
					new google.maps.Point( 8, 8 ), // anchor (move to center of marker)
					new google.maps.Size( 17, 17 ) // scaled size (required for Retina display icon)
				);

				var location = new google.maps.LatLng(coords.latitude, coords.longitude);

				marker = new google.maps.Marker({
					position: location,
					map: $scope.map.map,
					icon: locationIcon,
					title: "Oma sijaintisi"
				});

				$scope.map.map.setCenter(location);
			});

			ApartmentSearchService.AddPreQueryListener("mainSearch", ExecBeforeMainSearch);

			google.maps.event.addListener($scope.map.map, 'idle', function() {

				$scope.$apply(function() {
					$scope.bounds = $scope.map.map.getBounds();
					$scope.northEastBound = [$scope.bounds.getNorthEast().lat(),$scope.bounds.getNorthEast().lng()];
					$scope.southWestBound = [$scope.bounds.getSouthWest().lat(),$scope.bounds.getSouthWest().lng()];

					$scope.SearchModel.query.SetMapArea(
						$scope.northEastBound[0],
						$scope.northEastBound[1],
						$scope.southWestBound[0],
						$scope.southWestBound[1]
					);

					$scope.mapQuery.SetMapArea(
						$scope.northEastBound[0],
						$scope.northEastBound[1],
						$scope.southWestBound[0],
						$scope.southWestBound[1]
					);

					// Ekalla kerralla halutaan myös kartan keskitys, eli vedetään hookin läpi.
					if(firstSearchRun) {
						firstSearchRun = false;
						ApartmentSearchService.RunQuery($scope.SearchModel.query, "mainSearch", false);
					}
					else {
						RunBothQuerys();
					}
				});
			});
		};

		$scope.GoNext = function(info, apartments, marker) {
			var keys = Object.keys(apartments);
			if(keys.indexOf(info.key) >= keys.length-1) {
				$scope.markers[marker].marker.infoBoxScope.info = apartments[keys[0]];
			} else {
				$scope.markers[marker].marker.infoBoxScope.info = apartments[keys[keys.indexOf(info.key)+1]];
			}
		};

		$scope.GoPrev = function(info, apartments, marker) {
			var keys = Object.keys(apartments);
			if(keys.indexOf(info.key) === 0) {
				$scope.markers[marker].marker.infoBoxScope.info = apartments[keys[keys.length-1]];
			} else {
				$scope.markers[marker].marker.infoBoxScope.info = apartments[keys[keys.indexOf(info.key)-1]];
			}
		};

		$scope.SetMapHeight = function() {
			$scope.mapHeight = window.innerHeight - $('.l-placeholder--header').outerHeight(true);
		};
	}]
);